module.exports = __webpack_public_path__ + "static/media/spacebeer.639b9480.jpg";